import {ChartOptions} from 'chart.js'

import {CustomPluginOptions, CustomPlugins} from '../plugins'
import {RangeSelectOnChange} from '../plugins/rangeSelectPlugin'

import {
  chartTooltip,
  chartLegend,
  getTooltipLabel,
  commonTimeConfig,
  commonTicksConfig
} from './common.config'

export type ZoomMultiLineChartOptions = CustomPluginOptions & {
  onRangeSelection?: (RangeSelectOnChange) => void
  minimalDateRange?: number
  scaleToShowThreshold?: boolean
  yAxes?: Record<string, {suggestedMin?: number}>
}

const lang = navigator.language
const isUsFormat = lang.toLowerCase() === 'en-us'

export const areaChartOptions = (
  customOptions: ZoomMultiLineChartOptions
): ChartOptions & {plugins: CustomPlugins} => {
  return {
    plugins: {
      legend: {...chartLegend},
      tooltip: {
        ...chartTooltip,
        itemSort: (a, b) => (b.parsed.y ?? 0) - (a.parsed.y ?? 0),
        callbacks: {
          label: (context) =>
            getTooltipLabel({
              label: context.dataset.label,
              value: context.parsed.y,
              // @ts-expect-error - custom property is not in the type
              unit: context.dataset.unit
            }),
          title: (tooltipItems) => tooltipItems?.[0]?.label || ''
        }
      },
      rangeSelect: {
        // enabled: true,
        onSelectionChanged: (range: RangeSelectOnChange) => {
          if (customOptions.onRangeSelection) customOptions.onRangeSelection(range)
        },
        minimalDateRange: customOptions.minimalDateRange
      }
    },
    interaction: {
      intersect: false,
      mode: 'index'
    },
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.4
      }
    },
    scales: {
      y: {
        suggestedMax: customOptions?.scaleToShowThreshold ? 6 : 1,
        suggestedMin: customOptions?.scaleToShowThreshold ? -6 : 0,
        grid: {
          display: true,
          lineWidth: 1,
          color: 'rgba(0,0,0,0.05)'
        },
        border: {
          display: false
        },
        ticks: {
          padding: 0,
          callback: function () {
            return ''
          }
        }
      },
      ...customOptions.yAxes,
      x: {
        type: 'time',
        time: {
          ...commonTimeConfig(isUsFormat)
        },
        ticks: {
          ...commonTicksConfig
        },
        grid: {
          display: true,
          lineWidth: 1,
          color: 'rgba(0,0,0,0.05)'
        }
      }
    }
  }
}
